export enum RoundedButtonTypes {
  Primary = 'primary',
  Secondary = 'secondary',
}
